<template>
  <section class="find-salon-stats">
    <h2 class="find-salon-stats__title">Just Cuts By The Numbers</h2>
    <p class="find-salon-stats__lead">Why millions of clients choose Just Cuts every year.</p>
    <div class="find-salon-stats__grid">
      <div class="find-salon-stats__item">
        <div class="find-salon-stats__value">2.5M+</div>
        <div class="find-salon-stats__label">Style Cuts globally a year</div>
      </div>
      <div class="find-salon-stats__item">
        <div class="find-salon-stats__value">50K+</div>
        <div class="find-salon-stats__label">Style Cuts globally per week</div>
      </div>
      <div class="find-salon-stats__item">
        <div class="find-salon-stats__value">230+</div>
        <div class="find-salon-stats__label">Salons globally</div>
      </div>
      <div class="find-salon-stats__item">
        <div class="find-salon-stats__value">3,000+</div>
        <div class="find-salon-stats__label">Stylists globally</div>
      </div>
    </div>
  </section>
</template>


<script>

export default {

}
</script>
